var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as pako from "pako";
import axios from "axios";
import utils from "../utils/index";
import { CollectorId, ScreenSelectedArea } from "../types";
import ImageCollector from "../types/ImageCollector";
import ApiErrorReason from "../../../src/types/ApiErrorReason";
class ScreenshotsCollector extends ImageCollector {
    constructor(options, plasm) {
        super(options, plasm);
        this.state = {
            isShotsLimitReached: false,
        };
        const { screenshotWidth, screenshotHeight, screenshotQuality } = plasm.config;
        this.id = CollectorId.screen;
        this.IMAGE_DIMENSIONS = { width: screenshotWidth, height: screenshotHeight };
        this.IMAGE_QUALITY = screenshotQuality;
    }
    setupStream() {
        return __awaiter(this, void 0, void 0, function* () {
            if (utils.isAccessedFromMobileApp()) {
                const permissionStatus = yield window.flutter_inappwebview.callHandler("selectScreenSourceDialog");
                if (permissionStatus === false) {
                    throw new DOMException("App screen access failed", "NotAllowedError");
                }
                return new Promise((resolve) => {
                    resolve();
                });
            }
            this.stream = yield navigator.mediaDevices.getDisplayMedia();
            this.video.srcObject = this.stream;
            return new Promise((resolve) => {
                this.video.oncanplay = () => resolve();
            });
        });
    }
    buildSetupMeta() {
        const selectedArea = this.getSelectedArea();
        return { selectedArea, stream: this.stream };
    }
    getSelectedArea() {
        if (utils.isAccessedFromMobileApp()) {
            return ScreenSelectedArea.monitor;
        }
        if (this.stream == null) {
            return ScreenSelectedArea.unknown;
        }
        const track = this.stream.getVideoTracks()[0];
        const { label } = track;
        const settings = track.getSettings();
        if ((settings === null || settings === void 0 ? void 0 : settings.displaySurface) === "monitor" || label === "Primary Monitor") {
            return ScreenSelectedArea.monitor;
        }
        if ((settings === null || settings === void 0 ? void 0 : settings.displaySurface) === "window" || label.includes("Mozilla Firefox")) {
            return ScreenSelectedArea.application;
        }
        if ((settings === null || settings === void 0 ? void 0 : settings.displaySurface) === "browser") {
            return ScreenSelectedArea.tab;
        }
        if (utils.detectBrowser() === "safari") {
            return ScreenSelectedArea.monitor;
        }
        return ScreenSelectedArea.unknown;
    }
    sendImage(image, shotData) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const { sessionUuid } = this.plasm;
            const { trigger } = shotData;
            const isPageUnfocused = document.hasFocus() === false;
            const compressedImage = new Blob([pako.gzip(new Uint8Array(image))], {
                type: "application/octet-stream",
            });
            const extraData = yield this.generateExtraData();
            const url = `${this.plasm.options.plasmApiUrl}/screenshots`;
            const authToken = this.plasm.options.clientToken;
            const headers = { Authorization: `Bearer ${authToken}` };
            const data = {
                sessionUuid,
                trigger,
                isPageUnfocused,
                image: compressedImage,
                extraData,
            };
            try {
                yield axios.postForm(url, data, { headers });
                this.plasm.debug(`screenshot sent. trigger: ${trigger}, isPageUnfocused: ${isPageUnfocused}`);
            }
            catch (err) {
                const errorReason = (_d = (_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.details) === null || _d === void 0 ? void 0 : _d.reason;
                switch (errorReason) {
                    case ApiErrorReason.SESSION_SCREENSHOTS_LIMIT_REACHED: {
                        this.plasm.debug("session screenshots limit reached");
                        this.state.isShotsLimitReached = true;
                        yield this.stop();
                        break;
                    }
                    case ApiErrorReason.SESSION_EXPIRED:
                        yield this.plasm.stop();
                        break;
                    default:
                        throw err;
                }
            }
        });
    }
}
export default ScreenshotsCollector;
